import React, { useEffect, useState } from "react";
import { getAllEmployees } from "../../../../api/hrDashboard";

const SCORES = [96, 94, 92];

const BottomSection = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllEmployees()
      .then((res) => setEmployees(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const active    = employees.filter(e => !e.deboardEmp);
  const deboarded = employees.filter(e => e.deboardEmp);
  const getName   = (e) => `${e.firstName||""} ${e.lastName||""}`.trim() || "Employee";

  const deptMap = {};
  active.forEach(e => { 
    const d = e.departmentName || "Unknown"; 
    deptMap[d] = (deptMap[d] || 0) + 1; 
  });
  const depts = Object.entries(deptMap).slice(0, 3);

  const reviewOffsets = [3, 10, 17];
  const fmtDate = (offsetDays) => {
    const d = new Date(Date.now() + offsetDays * 86400000);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };

  const Loader = () => <div style={{ color: "#9ca3af", fontSize: 12 }}>Loading...</div>;

  return (
    <>
      <style>{`

        /* ✅ GRID LAYOUT (MAIN FIX) */
        .bs-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
        }

        .bs-card {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 16px;
          min-width: 0;
        }

        .bs-title {
          font-weight: 600;
          font-size: 13px;
          color: #1e293b;
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* Top Performers */
        .tp-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 0;
          border-bottom: 1px solid #f9fafb;
        }
        .tp-row:last-child { border-bottom: none; }

        .tp-avatar {
          width: 34px; height: 34px; border-radius: 50%;
          background: #e0e7ff; color: #4f6ef7;
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; font-weight: 700; flex-shrink: 0;
        }

        .tp-name { font-weight: 600; font-size: 12px; color: #1e293b; }
        .tp-role { font-size: 10px; color: #9ca3af; }
        .tp-score { font-weight: 700; font-size: 15px; color: #22c55e; margin-left: auto; }

        /* Needs Improvement */
        .ni-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 2px;
        }

        .ni-name { font-weight: 600; font-size: 13px; color: #1e293b; }
        .ni-role { font-size: 11px; color: #9ca3af; }
        .ni-pct  { font-weight: 700; font-size: 14px; color: #ef4444; }

        .ni-sub  { font-size: 10px; color: #ef4444; margin: 4px 0 8px; }

        .ni-bar-bg { height: 5px; background: #fee2e2; border-radius: 3px; overflow: hidden; }
        .ni-bar-fill { height: 100%; background: #ef4444; border-radius: 3px; }

        /* Upcoming Reviews */
        .ur-item {
          background: #f8fafc;
          border-radius: 8px;
          padding: 10px 12px;
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .ur-item:last-child { margin-bottom: 0; }

        .ur-dept { font-weight: 600; font-size: 12px; color: #1e293b; }
        .ur-note { font-size: 10px; color: #9ca3af; margin-top: 2px; }
        .ur-date { font-size: 12px; font-weight: 600; color: #4f6ef7; }

        /* ✅ Tablet */
        @media (max-width: 1024px) {
          .bs-row {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        /* ✅ Mobile */
        @media (max-width: 640px) {
          .bs-row {
            grid-template-columns: 1fr;
          }
        }

      `}</style>

      <div className="bs-row">

        {/* ── Top Performers ── */}
        <div className="bs-card">
          <div className="bs-title">⭐ Top Performers</div>
          {loading ? <Loader /> : active.slice(0, 3).length === 0 ? (
            <div style={{ fontSize: 12, color: "#9ca3af" }}>No employees found</div>
          ) : active.slice(0, 3).map((e, i) => (
            <div key={i} className="tp-row">
              <div className="tp-avatar">{(e.firstName||"?")[0].toUpperCase()}</div>
              <div style={{ flex: 1 }}>
                <div className="tp-name">{getName(e)}</div>
                <div className="tp-role">{e.designationName || "Staff"}</div>
              </div>
              <span className="tp-score">{SCORES[i]}</span>
            </div>
          ))}
        </div>

        {/* ── Needs Improvement ── */}
        <div className="bs-card">
          <div className="bs-title">
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#f59e0b", display: "inline-block" }} />
            Needs Improvement
          </div>
          {loading ? <Loader /> : deboarded.length === 0 ? (
            <div style={{ fontSize: 12, color: "#22c55e", fontWeight: 600 }}>✅ No issues found</div>
          ) : deboarded.slice(0, 2).map((e, i) => (
            <div key={i} style={{ marginBottom: 16 }}>
              <div className="ni-top">
                <div>
                  <div className="ni-name">{getName(e)}</div>
                  <div className="ni-role">{e.designationName || "Staff"}</div>
                </div>
                <span className="ni-pct">{40 + i * 18}%</span>
              </div>
              <div className="ni-sub">Missing targets for {i + 1} quarter{i > 0 ? "s" : ""}</div>
              <div className="ni-bar-bg">
                <div className="ni-bar-fill" style={{ width: `${40 + i * 18}%` }} />
              </div>
            </div>
          ))}
        </div>

        {/* ── Upcoming Reviews ── */}
        <div className="bs-card">
          <div className="bs-title">📅 Upcoming Reviews</div>
          {loading ? <Loader /> : depts.length === 0 ? (
            <div style={{ fontSize: 12, color: "#9ca3af" }}>No departments found</div>
          ) : depts.map(([dept], i) => (
            <div key={i} className="ur-item">
              <div>
                <div className="ur-dept">{dept} Team</div>
                <div className="ur-note">mark if any</div>
              </div>
              <span className="ur-date">{fmtDate(reviewOffsets[i])}</span>
            </div>
          ))}
        </div>

      </div>
    </>
  );
};

export default BottomSection;